import ProcessingNodeBase from '~/models/journey/ProcessingNodeBase'
import { ProfileStore } from '~/stores/profile'
import { SessionStore } from '~/stores/session'

export class CreateProfileNode extends ProcessingNodeBase {
  async run(): Promise<void> {
    await ProfileStore.createIfEmpty()
  }
}
